import React, { useRef, useEffect, useState } from 'react'
import {
  Form,
  Input,
  Button,
  Select,
  Upload,
  Modal,
  message,
  Card,
  Row,
  Col,
  TimePicker,
  notification,
  DatePicker,
  Tabs,
  Steps,
  Divider,
  Typography,
  Popconfirm,
  Space,
  Tag,
} from 'antd'
import {
  ProjectService,
  InformfixService,
  JobService,
  JobGroupService,
  TechnicainService,
  PersonnelService,
} from '../../../services'
import TextArea from 'antd/lib/input/TextArea'
import { number } from 'prop-types'
import iconHome from '../../../assets/images/informfix/icon-home.png'
import { Moment } from '../../../helpers'
import { inject, observer } from 'mobx-react'
import './style.scss'
import UploadList from './../uploadlist/index'
import JobEdit from '../../job/job-edit/index'
import JobAdd from '../../job/job-form'
import {
  UploadOutlined,
  ArrowRightOutlined,
  ArrowLeftOutlined,
  SaveOutlined,
  ReloadOutlined,
  CloseOutlined,
  LoadingOutlined,
  SmileOutlined,
  DeleteOutlined,
  PlusCircleOutlined,
  UserOutlined,
  EditOutlined,
} from '@ant-design/icons'
import { JobDateTime } from '../../job/JobDateTime'
import { JobStatus } from '../../job/JobStatus'
import { API, Config } from '../../../config'
import { JobTechnichian } from '../../job/JobTechnichian'

const { Option } = Select
const formatTime = 'HH:mm'
const MAX_IMAGE_UPLOAD = 10
const TabPane = Tabs.TabPane

const listPersonnel = []
const loadPersonnel = false

function getBase64(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader()
    reader.readAsDataURL(file)
    reader.onload = () => resolve(reader.result)
    reader.onerror = (error) => reject(error)
  })
}

function beforeUpload(file) {
  const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png'
  if (!isJpgOrPng) {
    message.error('อัพโหลดได้เฉพาะ JPG/PNG เท่านั้น!', 5)
  }
  const isLt2M = file.size / 1024 / 1024 < 5
  if (!isLt2M) {
    message.error('ขนาดภาพต้องไม่เกิน 5MB!', 5)
  }
  return isJpgOrPng && isLt2M
}

const openNotificationWithIcon = (type, message, description = '') => {
  notification[type]({
    message: message ? message : 'Notification Title',
    description: description,
  })
}

const layout = {
  labelCol: {
    span: 8,
  },
  wrapperCol: {
    span: 16,
  },
}
const tailLayout = {
  wrapperCol: {
    offset: 8,
    span: 16,
  },
}

// reset form fields when modal is form, closed
const useResetFormOnCloseModal = ({ form, visible }) => {
  const prevVisibleRef = useRef()
  useEffect(() => {
    prevVisibleRef.current = visible
  }, [visible])
  const prevVisible = prevVisibleRef.current
  useEffect(() => {
    if (!visible && prevVisible) {
      form.resetFields()
    }
  }, [visible])
}

/***********************************
 * Modal เพิ่มคิวงาน
 */
const ModalJobForm = ({ visible, onCancel, jobgroups, technicians }) => {
  const [form] = Form.useForm()
  const [techniciansTemp, setTechniciansTemp] = useState()
  const [listPersonnel, setListPersonnel] = useState([])
  const [loadPersonnel, setLoadPersonnel] = useState(false)

  useResetFormOnCloseModal({
    form,
    visible,
  })

  const onOk = () => {
    form.submit()
  }

  const onFinishJob = (values) => {
    console.log('onFinishJob', values)
  }

  /**
   *  ข้อมูลพนักงาน
   */
  const getPersonnel = (params) => {
    PersonnelService.search(params)
      .then((rs) => {
        if (rs) {
          let data = []
          const items = rs.data.items
          if (items) {
            items.map((item, index) => {
              data.push({
                value: item.user_id,
                text: item.fullnameTH,
              })
            })
          }
          setListPersonnel(data)
        }
      })
      .catch((err) => {})
  }

  const onChangeResponsible = (value) => {
    let responsibleName = ''
    const user = this.state.techniciansTemp.map((item, index) => {
      if (item.id == value) {
        responsibleName = `${item.firstname} ${item.lastname}`
        console.log(responsibleName)
        form.current.setFieldsValue({
          responsible_name: responsibleName,
        })
      }
    })
  }

  const onSearchPersonnel = (search) => {
    if (search && search.length >= 2) {
      setLoadPersonnel(true)
      setTimeout(() => {
        getPersonnel({ q: search })
        setLoadPersonnel(false)
      }, 1000)
    }
  }
  const onSelectPersonnel = (value) => {
    if (value) {
      listPersonnel.map((item) => {
        if (Number(item.value) == Number(value)) {
          form.setFieldsValue({
            responsible_id: item.value,
            responsible_name: item.text,
          })
        }
      })
    }
  }
  const onDeselectPersonnel = (value) => {
    form.setFieldsValue({
      responsible_id: null,
    })
  }
  const onSelectJobstatus = (value) => {
    form.setFieldsValue({
      job_status: value,
    })
  }

  return (
    <Modal
      title="เพิ่มคิวงาน"
      open={visible}
      onOk={onOk}
      onCancel={onCancel}
    >
      <Form form={form} layout="vertical" name="jobForm" onFinish={onFinishJob}>
        <Form.Item
          label="หมวดหมู่"
          name="group_id"
          rules={[{ required: true, message: 'หมวดหมู่' }]}
        >
          <Select
            allowClear
            placeholder="--เลือกหมวดหมู่--"
            showSearch
            filterOption={(input, option) =>
              option.props.children
                .toString()
                .toLowerCase()
                .indexOf(input.toString().toLowerCase()) >= 0
            }
          >
            {jobgroups
              ? jobgroups.map((d) => (
                  <Option key={d.id} value={d.id}>
                    {d.name}
                  </Option>
                ))
              : null}
          </Select>
        </Form.Item>
        <Form.Item
          name="title"
          label="งาน"
          rules={[
            {
              required: true,
              message: 'ชื่องาน',
            },
          ]}
        >
          <Input />
        </Form.Item>
        <Form.Item
          name="description"
          label="รายละเอียด"
          rules={[
            {
              required: false,
            },
          ]}
        >
          <Input.TextArea rows={4} />
        </Form.Item>
        <Form.Item
          name="rangedate"
          label="เวลา"
          rules={[
            {
              required: false,
            },
          ]}
        >
          <DatePicker.RangePicker
            showTime={{ format: 'HH:mm' }}
            format="YYYY-MM-DD HH:mm"
            minuteStep={15}
            secondStep={10}
          />
        </Form.Item>
        <Form.Item
          label="ผู้รับผิดชอบ"
          rules={[{ required: false, message: 'ผู้รับผิดชอบงาน' }]}
          name="responsible_name"
        >
          <Select
            placeholder="--พิมพ์ค้นหา--"
            showSearch
            allowClear
            optionFilterProp="children"
            onSearch={onSearchPersonnel}
            onSelect={onSelectPersonnel}
            onDeselect={onDeselectPersonnel}
            filterOption={(input, option) =>
              option.props.children
                .toString()
                .toLowerCase()
                .indexOf(input.toString().toLowerCase()) >= 0
            }
          >
            {listPersonnel.map((d, key) => (
              <Option key={key} value={d.value}>
                {d.text}{' '}
              </Option>
            ))}
          </Select>
        </Form.Item>
        <Form.Item
          shouldUpdate
          label="ผู้รับผิดชอบ"
          name="responsible_id"
          rules={[{ required: false, message: 'ผู้รับผิดชอบงาน' }]}
          noStyle
        >
          <Input type="hidden" readOnly htmltype="hidden" />
        </Form.Item>
        <Form.Item
          label="ช่าง"
          rules={[{ required: false, message: 'ช่าง' }]}
          name="technicians"
        >
          <Select
            mode="multiple"
            placeholder="--ช่าง--"
            showSearch
            allowClear
            // onChange={this.onChangeResponsible}
            filterOption={(input, option) =>
              option.props.children
                .toString()
                .toLowerCase()
                .indexOf(input.toString().toLowerCase()) >= 0
            }
          >
            {technicians
              ? technicians.map((d) => (
                  <Option key={d.value} value={d.value}>
                    {d.text}{' '}
                    {d.technician_type
                      ? '(' + d.technicianTypeName + ')'
                      : null}
                  </Option>
                ))
              : null}
          </Select>
        </Form.Item>
        <Form.Item
          name="technician_name_other"
          label="ช่างอื่น ๆ / ผู้รับเหมา"
          rules={[
            {
              required: false,
            },
          ]}
        >
          <Input />
        </Form.Item>
      </Form>
    </Modal>
  )
}

@inject('informStore')
@observer
class InformEdit extends React.Component {
  state = {
    homes: [],
    projects: [],
    loadingProject: false,
    loading: false,
    disabledSelectHome: true,
    informfixId: number,
    informfix: {},
    galleries: [],
    previewVisible: false,
    previewImage: '',
    previewImageItem: null,
    fileList: [],
    images: [],
    currentStep: 0,
    fileLists: [
      {
        uid: '-1',
        name: 'image.png',
        status: 'done',
        url: iconHome,
      },
      {
        uid: '-2',
        name: 'image.png',
        status: 'done',
        url: iconHome,
      },
    ],
    currentTime: '',
    jobs: [],
    visibleModalJob: false,
    visibleModalJobEdit: false,
    jobgroups: [],
    technicians: [],
    techniciansTemp: [],
    selectedResponsible: [],
    selectedTechnician: [],
    // edit job
    jobId: '',
    job: {},
  }
  constructor() {
    super()
    this.onChangeTime = this.onChangeTime.bind(this)
  }

  formRef = React.createRef()

  async showMessage(msg, duration = 3) {
    return await message.success(msg, duration)
  }

  onSaveInform = (values) => {
    const informfixId = this.props.informfixId
    this.setState({ loading: true })
    values = {
      ...values,
    }

    // ปรับเวลา timezone ให้ตรงก่อนส่งไปเก็บที่ server เนื่องจากค่่าที่เลือกับที่ส่งจากฟอร์มไม่ตรงกัน
    if (values.contact_time) {
      values.contact_time = Moment(values.contact_time)
        .utc(7)
        .format(formatTime)
    }

    // ถ้าเวลาเป็น timestamp อยู่แล้วจากไม่ต้องปรับ  utc() ไม่งั้นเวลาจะไม่ตรง
    if (values.date_inform) {
      values.date_inform = Moment(values.date_inform)
    }
    // ถ้าเวลาเป็น timestamp อยู่แล้วจากไม่ต้องปรับ  utc() ไม่งั้นเวลาจะไม่ตรง
    if (values.time_inform) {
      values.time_inform = Moment(values.time_inform)
    }

    InformfixService.update(informfixId, values)
      .then((rs) => {
        if (rs) {
          const msg = rs.data.message
          const data = rs.data.data
          this.setState({
            loading: false,
            informfix: data,
          })
          // this.resetForm();
          // openNotificationWithIcon('success', msg)
          this.props.informStore.setItem(data)
          this.props.onUpdate(data)
          // this.props.hideModal()
          // this.next()
        }
      })
      .catch((err) => {
        this.setState({ loading: false })
      })
  }

  onFinishFailed = ({ errorFields }) => {
    this.formRef.current.scrollToField(errorFields[0].name)
  }

  componentWillMount() {
    console.log('data edit', this.props.item)
    this.props.informStore.setGalleryItems([])
    this.getProjects()
    this.setState({
      informfixId: this.props.informfixId,
    })

    this.getGalleryById(this.props.informfixId)
    if (this.props.formStep) {
      this.setState({
        currentStep: this.props.formStep,
      })
    }
  }
  componentDidMount() {
    const informfixId = this.props.informfixId
    this.getInfirmfix(informfixId)
    this.getJobsByInformId(informfixId)
    this.getGalleryById(informfixId)
    this.getJobGroup()
    this.getTechnicians()
  }

  getInfirmfix(id) {
    this.setState({
      loading: true,
    })
    InformfixService.view(id)
      .then((rs) => {
        if (rs && rs.data['data']) {
          this.setState({ loading: false, informfix: rs.data['data'] })
          // this.getGalleryById(id)
          this.setFormFeilds(rs.data['data'])
        }
      })
      .catch((err) => this.setState({ loading: false }))
  }

  getJobsByInformId = (id) => {
    InformfixService.getJobs(id).then((rs) => {
      if (rs && rs.data.data) {
        const jobs = rs.data.data
        this.setState({
          jobs: jobs,
        })
        this.props.onUpdateJobs(jobs, id)
      }
    })
  }

  /**
   * ใส่ค่าเริมต้นให้ฟอร์ม
   */
  setFormFeilds = (item) => {
    if (item.id) {
      this.formRef.current.setFieldsValue({
        id: item.id,
        subject: item.subject,
        description: item.description,
        home_id: item.home_id,
        project_id: item.project_id,
        contact_time: item.contact_time
          ? Moment(item.contact_time, formatTime)
          : null,
        contact_phone: item.contact_phone,
        informer: item.informer,
        date_inform: Moment.unix(item.date_inform),
        time_inform: Moment.unix(item.time_inform),
      })
    }
  }

  resetForm() {
    this.formRef.current.resetFields()
  }

  /**
   * Gallery data
   */
  getGalleryById(id) {
    let data = []
    let dataGallery = []
    let photos = []
    this.setState({
      images: [],
      fileList: [],
    })
    this.props.informStore.setGalleryItems([])
    InformfixService.getImages(id).then((rs) => {
      if (rs) {
        rs.data['data'].forEach((f, index) => {
          data.push({
            uid: f.id,
            name: f.filename,
            status: 'done',
            url: f.thumbnail,
            fullUrl: f.url,
            description: f.description,
          })
        })
        rs.data['data'].forEach((f, index) => {
          dataGallery.push({
            src: f.url,
            thumbnail: f.thumbnail,
            original: f.url,
            thumbnailWidth: 320,
            thumbnailHeight: 174,
            isSelected: false,
            caption: f.name,
          })
        })
        // photos
        rs.data['data'].forEach((photo, index) => {
          photos.push({
            original: photo.url,
            thumbnail: photo.thumbnail,
          })
        })
      }
      this.setState({
        fileList: data,
        galleries: dataGallery,
        photos: photos,
        images: rs.data['data'],
      })
      this.props.informStore.setGalleryItems(rs.data['data'])
    })
  }

  /**
   * ข้อมูลโครงการ
   */
  getProjects = () => {
    this.setState({ loadingProject: true })
    this.setState({ homes: [] })
    ProjectService.all()
      .then((rs) => {
        if (rs) {
          let data = []
          rs.data['data'].map((item) => {
            let homes = []
            if (item.homeCustomer) {
              item.homeCustomer.map((home) => {
                homes.push({
                  value: home.id,
                  label:
                    'แปลง ' +
                    home.plan_no +
                    (home.home_no ? ' (เลขที่ ' + home.home_no + ')' : ''),
                })
              })
            }
            data.push({
              value: item.id,
              label: item.name,
              children: homes,
            })
          })
          this.setState({ loadingProject: false })
          this.setState({ projects: data, loading: false })
        }
      })
      .catch((err) => this.setState({ loadingHome: false }))
  }
  /**
   * ข้อมูลบ้านในโครงการนั้นๆ
   */
  getHomeByProjectId = (projectId) => {
    this.setState({ disabledSelectHome: true })
    ProjectService.getHomesByProject(projectId)
      .then((rs) => {
        if (rs) {
          this.setState({ disabledSelectHome: false })
          this.setState({ homes: rs.data['data'], loading: false })
        }
      })
      .catch((err) => this.setState({ loadingHome: false }))
  }
  /**
   * ข้อมูลช่าง
   */
  getTechnicians() {
    TechnicainService.all()
      .then((rs) => {
        if (rs) {
          let data = []
          const items = rs.data.data
          if (items) {
            items.map((item, index) => {
              data.push({
                value: item.id,
                text:
                  item.firstname +
                  ' ' +
                  item.lastname +
                  (item.technician_type
                    ? ' (' + item.technicianTypeName + ')'
                    : null),
              })
            })
          }
          this.setState({ technicians: data, techniciansTemp: items })
        }
      })
      .catch((err) => {})
  }
  onChangeResponsible = (value) => {
    console.clear()
    console.log('onChangeResponsible', value)
    let responsibleName = ''
    const user = this.state.techniciansTemp.map((item, index) => {
      if (item.id == value) {
        responsibleName = `${item.firstname} ${item.lastname}`
        console.log(responsibleName)
        this.formRef.current.setFieldsValue({
          responsible_name: responsibleName,
        })
      }
    })
  }
  /**
   * ข้อมูลหมวดหมู่งาน
   */
  getJobGroup = () => {
    this.setState({ jobgroups: [] })
    JobGroupService.all()
      .then((rs) => {
        if (rs) {
          this.setState({ jobgroups: rs.data['data'] })
        }
      })
      .catch((err) => {})
  }

  /**
   * เมื่อเปลี่ยนโครงการ
   */
  onChangeProject = (value) => {
    if (value) {
      this.setState({ homes: [], disabledSelectHome: true })
      this.getHomeByProjectId(value)
    }
  }

  handleCancelPreviewImage = () => this.setState({ previewVisible: false })

  handlePreview = async (file) => {
    if (!file.url && !file.preview) {
      file.preview = await getBase64(file.originFileObj)
    }

    this.setState({
      previewImage: file.fullUrl || file.preview,
      previewImageItem: file,
      previewVisible: true,
    })
  }

  previewImage = async (file) => {
    if (!file.url && !file.preview) {
      file.preview = await getBase64(file.originFileObj)
    }

    this.setState({
      previewImage: file.fullUrl || file.preview,
      previewImageItem: file,
      previewVisible: true,
    })
  }

  onRemoveImage = async (file) => {
    let informfixId = this.props.informfixId
    InformfixService.deleteImage(informfixId, file.uid).then(() => {
      this.setState((state) => {
        const index = state.fileList.indexOf(file)
        const newFileList = state.fileList.slice()
        newFileList.splice(index, 1)
        return {
          fileList: newFileList,
        }
      })
      this.getGalleryById(informfixId)
    })
  }

  handleChange = ({ fileList }) => this.setState({ fileList })

  /**
   * อัพโหลดได้เฉพาะ
   */
  handleCustomUpload = ({ onSuccess, onError, file }) => {
    let informfixId = this.props.informfixId
    const formData = new FormData()
    formData.append('file', file)
    this.setState({
      fileList: [],
      images: [],
    })
    let gallery = this.props.informStore.itemGallery
    InformfixService.upload(informfixId, formData)
      .then((rs) => {
        // this.getGalleryById(informfixId)
        gallery.unshift(rs.data)
        this.props.informStore.setGalleryItems(gallery)
        onSuccess(null, formData)
      })
      .catch((error) => {
        if (error.response) {
          message.error(error.response.data.message)
        }
      })
  }

  onChangeImage = (info) => {
    const reader = new FileReader()
    reader.onloadend = (obj) => {
      this.imageDataAsURL = obj.srcElement.result
    }
    reader.readAsDataURL(info.file.originFileObj)
  }

  onChangeTime = (time) => {
    this.setState({
      currentTime: time,
    })
  }
  onTimeChange(time) {
    this.setState({ time })
  }

  setImgDescription = (e, item, index) => {
    const value = e.target.value || null
    console.log('index', index)
    InformfixService.setImgDescription(item.uid, {
      description: value,
    }).then((rs) => {
      let previewImageItem = { ...this.state.previewImageItem }
      previewImageItem.description = value
      this.setState({
        previewImageItem,
      })
    })
  }

  next() {
    const currentStep = this.state.currentStep + 1
    console.log('next', currentStep)
    this.setState({ currentStep })
  }

  prev() {
    const currentStep = this.state.currentStep - 1
    this.setState({ currentStep })
  }

  /**
   * เช็ตค่าตัวแปรซ่อน/แสดง modal job
   */
  setVisibleJobModal = (value) => {
    this.setState({
      visibleModalJob: value,
    })
  }

  showJobModal = () => {
    this.setVisibleJobModal(true)
  }

  hideJobModal = () => {
    this.setVisibleJobModal(false)
  }

  onFinishJob = (values) => {
    console.log('Finish:', values)
  }

  /**
   * ลบงาน
   */
  deleteJob = (item) => {
    let jobs = [...this.state.jobs]
    const id = item.id
    const index = jobs.indexOf(item)
    JobService.delete(id).then((rs) => {
      jobs.splice(index, 1)
    })
    jobs.splice(index, 1)
    this.props.onUpdateJobs(jobs, this.props.informfixId)
    this.setState({
      jobs: jobs,
    })
  }
  /**
   * แก้ไขงาน
   */
  editJob = (item) => {
    let jobs = [...this.state.jobs]
    const id = item.id
    const index = jobs.indexOf(item)
    this.props.informStore.setEditId(id)
    this.setState({
      jobId: id,
      job: jobs[index],
    })
    console.log(this.state.jobId, this.state.job)
    this.setVisibleModalJobEdit(true)
  }

  setVisibleModalJobEdit = (value) => {
    this.setState({
      visibleModalJobEdit: value,
    })
  }

  hideModalJobEdit = () => {
    console.log('hide modal')
    this.getJobsByInformId(this.state.job.inform_fix_id)
    this.setState({
      visibleModalJobEdit: false,
      jobId: '',
      job: {},
    })
    this.props.informStore.setEditId('')
  }

  render() {
    const {
      projects,
      homes,
      disabledSelectHome,
      loading,
      previewVisible,
      previewImage,
      previewImageItem,
      fileList,
      galleries,
      photos,
      currentStep,
      informfix,
      technicians,
      technichiansTemp,
      selectedResponsible,
      selectedTechnician,
    } = this.state

    const { informfixId, item } = this.props

    const formLayout = 'horizontal'
    const formItemLayout =
      formLayout === 'horizontal'
        ? {
            labelCol: { xs: { span: 24 }, sm: { span: 8 }, md: { span: 5 } },
            wrapperCol: {
              xs: { span: 24 },
              sm: { span: 16 },
              md: { span: 16 },
            },
          }
        : null
    const buttonItemLayout =
      formLayout === 'horizontal'
        ? {
            wrapperCol: {
              xs: { span: 24, offset: 0 },
              sm: { span: 16, offset: 8 },
              md: { span: 16, offset: 5 },
            },
          }
        : null

    const listProjectItems = projects.map((item, index) => (
      <Option key={index} value={item.value}>
        {item.label}
      </Option>
    ))
    const listHomeItems = homes.map((item, index) => (
      <Option key={item.id} value={item.id}>
        {(item.homeType ? item.homeType.name : '') +
          (item.plan_no ? ' แปลง ' + item.plan_no : '') +
          (item.home_no ? ' (เลขที่ ' + item.home_no + ')' : '')}
      </Option>
    ))

    const uploadButton = (
      <Button icon={<UploadOutlined />} type="info">
        {/* <Icon type=mage" /> */}
        อัพโหลดรูปภาพ
      </Button>
    )
    const uploadUrl = API.baseUrl + '/informfix/' + informfixId + '/upload'
    const propsUpload = {
      action: uploadUrl,
      listType: 'picture',
      defaultFileList: [...fileList],
      className: 'upload-list-inline',
    }
    const props = {
      onRemove: (file) => {
        this.setState((state) => {
          const index = state.fileList.indexOf(file)
          const newFileList = state.fileList.slice()
          newFileList.splice(index, 1)
          return {
            fileList: newFileList,
          }
        })
      },
      beforeUpload: (file) => {
        this.setState((state) => ({
          fileList: [...state.fileList, file],
        }))
        return false
      },
      fileList,
    }

    //ตรจสอบเงือนไขการแสดงปุ่มบันทึกแก้ไข
    const CanEdit = (item) => {
      return item.work_status != Config.informfix.status.COMPLETE.value
        ? true
        : false
    }

    const JobItems = () => {
      let items = []
      if (this.state.jobs) {
        this.state.jobs.map((job, index) => {
          if (job.start_time) {
            job.start_time = Moment(job.start_time).utc(7)
          }
          if (job.end_time) {
            job.end_time = Moment(job.end_time).utc(7)
          }
          items.push(job)
        })
      }
      return items
    }

    const filteredOptionsResponsible = technicians.filter(
      (o) => !selectedResponsible.includes(o),
    )
    const filteredOptionsTechnician = technicians.filter(
      (o) => !selectedTechnician.includes(o),
    )

    // แสดงวันที่
    const showFormatDate = (datetime) => {
      let date = Moment(datetime)
      if (date.isValid()) {
        return date.format('ll')
      } else {
        return null
      }
    }

    const showProjectDetail = () => {
      return (
        <>
          <div>
            {informfix.project && informfix.project.name != undefined
              ? informfix.project.name
              : '-'}
          </div>
          <div>
            เลขที่{' '}
            {informfix.home && informfix.home.home_no != undefined
              ? informfix.home.home_no
              : '-'}{' '}
            แปลง{' '}
            {informfix.home && informfix.home.plan_no != undefined
              ? informfix.home.plan_no
              : '-'}
          </div>
        </>
      )
    }

    ////////////////////////// TAB 1 /////////////////////////////////
    const content1 = (
      <React.Fragment>
        <div>
          {informfix.home && informfix.home.transfer_date ? (
            <>
              <div>
                ผู้รับโอนกรรมสิทธิ์:{' '}
                {informfix.home.customer_name
                  ? showFormatDate(informfix.home.customer_name)
                  : '-'}
              </div>
              <div>
                วันที่โอน:{' '}
                {informfix.home.transfer_date
                  ? showFormatDate(informfix.home.transfer_date)
                  : '-'}
              </div>
              {informfix.home && informfix.home.warrantyExpired ? (
                <>
                  <div>
                    หมดรับประกัน 1 ปี:{' '}
                    {showFormatDate(informfix.home.warrantyExpired['1y'])}
                  </div>
                  <div>
                    หมดรับประกันโครงสร้าง (5 ปี):{' '}
                    {showFormatDate(informfix.home.warrantyExpired['5y'])}
                  </div>
                </>
              ) : null}
            </>
          ) : null}
        </div>
        <Form
          ref={this.formRef}
          onFinish={this.onSaveInform}
          onFinishFailed={this.onFinishFailed}
          style={{ display: 'block' }}
          initialValues={{
            id: informfix ? informfix.id : null,
            subject: informfix ? informfix.subject : null,
            description: informfix ? informfix.description : null,
            home_id: informfix.home_id,
            project_id: informfix.project_id,
            contact_time: informfix.contact_time
              ? Moment(informfix.contact_time, formatTime)
              : null,
            contact_phone: informfix ? informfix.contact_phone : null,
            informer: informfix ? informfix.informer : null,
            date_inform: informfix.date_inform
              ? Moment.unix(informfix.date_inform)
              : null,
            time_inform: informfix.time_inform
              ? Moment.unix(informfix.time_inform)
              : null,
          }}
        >
          <Form.Item label="โครงการ" {...formItemLayout}>
            {informfix.project ? informfix.project.name : ''}
          </Form.Item>
          <Form.Item label="บ้าน" {...formItemLayout}>
            เลขที่ {informfix.home ? informfix.home.home_no : ''} แปลง{' '}
            {informfix.home ? informfix.home.plan_no : ''}
          </Form.Item>
          <Form.Item name="id" noStyle>
            <Input type="hidden" />
          </Form.Item>
          <Form.Item name="project_id" noStyle>
            <Input type="hidden" />
          </Form.Item>
          <Form.Item name="home_id" noStyle>
            <Input type="hidden" />
          </Form.Item>
          <Form.Item
            label="วันที่แจ้ง"
            {...formItemLayout}
            name="date_inform"
            rules={[{ required: true, message: 'เวลาที่แจ้ง' }]}
          >
            <DatePicker
              showTime={{
                minuteStep: 15,
              }}
              inputReadOnly
              ShowToday
              format="DD/MM/YYYY HH:mm"
              style={{ width: '100%' }}
            />
          </Form.Item>
          {/* <Form.Item
            label="หัวข้อ"
            {...formItemLayout}
            name="subject"
            rules={[{ required: true, message: 'กรุณากรอกหัวข้อ' }]}
          >
            <Input placeholder="หัวข้อ" />
          </Form.Item> */}
          <Form.Item
            label="รายละเอียด"
            {...formItemLayout}
            name="description"
            rules={[
              {
                required: false,
                message: 'กรุณากรอกข้อความ และรายละเอียด!',
              },
            ]}
          >
            <TextArea name="description" rows={5} placeholder="รายละเอียด" />
          </Form.Item>
          <Form.Item
            label="เวลาที่สะดวก"
            {...formItemLayout}
            name="contact_time"
            rules={[{ required: false, message: 'เวลาที่สะดวกให้ติดต่อกลับ' }]}
          >
            <TimePicker format={formatTime} minuteStep={15} secondStep={10} />
          </Form.Item>
          <Form.Item
            label="เบอร์โทร"
            {...formItemLayout}
            name="contact_phone"
            rules={[
              {
                required: false,
                message: 'เบอร์โทรสำหรับให้เจ้าหน้าที่ติดต่อกลับ',
              },
            ]}
          >
            <Input
              type="text"
              placeholder="เบอร์โทรสำหรับให้เจ้าหน้าที่ติดต่อกลับ"
            />
          </Form.Item>

          <Form.Item label="ผู้แจ้ง" {...formItemLayout} name="informer">
            <Input type="text" placeholder="ชื่อผู้แจ้ง" />
          </Form.Item>
          <Form.Item {...buttonItemLayout}>
            <Button
              size="middle"
              type="primary"
              htmlType="submit"
              className="submit"
              disabled={!CanEdit(informfix)}
              icon={<SaveOutlined />}
            >
              บันทึก
            </Button>{' '}
            <Button
              size="middle"
              type="default"
              htmlType="reset"
              className="submit"
              onClick={() => this.resetForm()}
              icon={<ReloadOutlined />}
            >
              รีเซ็ต
            </Button>
          </Form.Item>
        </Form>
      </React.Fragment>
    )
    ////////////////////////// TAB image /////////////////////////////////
    const content2 = (
      <React.Fragment>
        <div>
          <Upload
            listType="picture"
            // className="avatar-uploader"
            showUploadList={false}
            beforeUpload={beforeUpload}
            onChange={this.handleChangeImage}
            onRemove={this.onRemoveImage}
            customRequest={this.handleCustomUpload}
            multiple={true}
            maxCount={5}
          >
            {fileList.length >= MAX_IMAGE_UPLOAD ? null : uploadButton}
          </Upload>
        </div>

        <Divider />
        <div
          style={{
            height: 350,
            overflowY: 'scroll',
          }}
        >
          <UploadList
            key={informfixId}
            informfixId={informfixId}
            fileList={this.state.images}
            reload={() => this.getGalleryById(informfixId)}
          />
        </div>

        <Modal
          open={previewVisible}
          footer={
            <div align="center">
              {previewImageItem ? previewImageItem.description : null}
            </div>
          }
          onCancel={this.handleCancelPreviewImage}
        >
          <img
            alt={informfix.subject}
            style={{ width: '100%' }}
            src={previewImage}
          />
        </Modal>
      </React.Fragment>
    )
    ////////////////////////// TAB 3 /////////////////////////////////
    const content3 = (
      <React.Fragment>
        <div className="ant-table ant-table-small ant-table-bordered">
          <div
            className="ant-table"
            style={{
              height: 350,
              overflowY: 'scroll',
            }}
          >
            {this.state.jobs.map((job, index) => (
              <Card
                key={index}
                style={{
                  marginBottom: 5,
                  backgroundColor: '#f3f3f3',
                  border: 'solid 1px #222222',
                }}
              >
                <h3>
                  {Config.job.status.COMPLETE.value != job.job_status &&
                  job.informFix.work_status !=
                    Config.informfix.status.COMPLETE.value ? (
                    <Popconfirm
                      title="ต้องการลบรายละเอียดงานนี้ ใช่หรือไม่ ?"
                      okText="ใช่ ลบเดี๋ยวนี้เลย"
                      cancelText="ไม่"
                      onConfirm={() => this.deleteJob(job)}
                    >
                      <Button
                        type="danger"
                        size="small"
                        icon={<DeleteOutlined />}
                      ></Button>
                    </Popconfirm>
                  ) : null}
                  <Space /> <Space />
                  <Button
                    type="default"
                    size="small"
                    icon={<EditOutlined />}
                    onClick={() => this.editJob(job)}
                  ></Button>
                  {'  '} {job.list}
                </h3>
                <table style={{ width: '100%' }}>
                  <tbody>
                    <tr>
                      <td>
                        ตั้งแต่เวลา {<JobDateTime datetime={job.start_time} />}
                      </td>
                      <td>ถึงเวลา {<JobDateTime datetime={job.end_time} />}</td>
                      <td></td>
                    </tr>
                  </tbody>
                </table>
                <p>{job.description}</p>
                <Tag key={job.id}>{job.group ? job.group.name : ''}</Tag>
                ID#{job.id}{' '}
                <JobStatus name={job.jobStatusName} statusId={job.job_status} />
                <UserOutlined /> {job.responsible_name}(ผู้รับผิดชอบ)
                <JobTechnichian technichians={job.technichians} />
              </Card>
            ))}
          </div>
        </div>
        <Form.Provider
          onFormFinish={(name, { values, forms }) => {
            if (name === 'jobForm') {
              if (values.rangedate) {
                const startTime =
                  values.rangedate[0] && Moment(values.rangedate[0]).isValid()
                    ? Moment(values.rangedate[0])
                        .utc(7)
                        .format('YYYY-MM-DD HH:mm')
                    : null
                const endTime =
                  values.rangedate[1] && Moment(values.rangedate[1]).isValid()
                    ? Moment(values.rangedate[1])
                        .utc(7)
                        .format('YYYY-MM-DD HH:mm')
                    : null

                values.start_time = startTime
                values.end_time = endTime
                delete values.rangedate
              }

              let allParams = {
                ...{
                  inform_fix_id: informfix.id,
                  project_id: informfix.project_id,
                  home_id: informfix.home_id,
                },
                ...values,
              }
              JobService.create(allParams).then((rs) => {
                this.getJobsByInformId(this.props.informfixId)
              })

              const { basicForm } = forms
              const jobs = basicForm.getFieldValue('jobs') || []
              // basicForm.setFieldsValue({
              //   jobs: [...jobs, values],
              // })
              this.setVisibleJobModal(false)
            }
          }}
        >
          <Form
            {...layout}
            name="basicForm"
            onFinish={this.onFinishJob}
            initialValues={{
              inform_fix_id: this.props.informfixId,
            }}
          >
            <Form.Item {...tailLayout}></Form.Item>
          </Form>
          <div align="center">
            <Button
              htmlType="button"
              type="dark"
              style={{ margin: 5, backgroundColor: 'green', color: '#ffffff' }}
              onClick={this.showJobModal}
              icon={<PlusCircleOutlined />}
              shape="round"
            >
              เพิ่มคิวงาน
            </Button>
          </div>
        </Form.Provider>

        {/* //////// MODAL เพิ่มคิวงาน//////////// */}
        {/* <ModalJobForm
          visible={this.state.visibleModalJob}
          onCancel={this.hideJobModal}
          jobgroups={this.state.jobgroups}
          technicians={this.state.technicians}
        /> */}
        {this.state.visibleModalJob ? (
          <JobAdd
            footer=""
            informId={this.state.informfixId}
            projectId={this.state.informfix.project_id}
            homeId={this.state.informfix.home_id}
            visible={this.state.visibleModalJob}
            onCreated={(data) => {
              this.getJobsByInformId(this.state.informfixId)
              this.hideJobModal()
            }}
            onCancel={(data) => {
              this.hideJobModal()
            }}
          />
        ) : null}

        {/* ////////////// START Modal Edit /////////// */}
        {this.state.jobId && this.state.visibleModalJobEdit ? (
          <JobEdit
            jobId={this.state.jobId}
            job={this.state.job}
            projects={this.state.projects}
            hideModal={this.hideModalJobEdit}
            visible={this.state.visibleModalJobEdit}
            onUpdated={(data) => {}}
            onCancel={(data) => {
              this.setVisibleModalJobEdit(false)
            }}
          />
        ) : null}
      </React.Fragment>
    )

    const steps = [
      {
        title: 'ข้อมูลแจ้งซ่อม',
        content: content1,
      },
      {
        title: 'รูปภาพ',
        content: content2,
      },
      {
        title: 'งาน',
        content: content3,
      },
    ]

    const { Step } = Steps

    const showFileList = (fileList) => {
      return fileList
        ? fileList.map((file, index) => (
            <Card key={index}>
              <Row gutter={3}>
                <Col xs={9}>
                  <img
                    style={{ width: 120, cursor: 'pointer' }}
                    key={'img-' + file.uid}
                    src={file.url}
                    onClick={() => this.previewImage(file)}
                  />
                </Col>
                <Col xs={14}>
                  {file.description}
                  <TextArea
                    key={index}
                    defaultValue={file.description}
                    onBlur={(e) => this.setImgDescription(e, file, index)}
                  ></TextArea>
                </Col>
                <Col xs={1}>
                  <Button
                    icon="delete"
                    type="danger"
                    onClick={() => this.onRemoveImage(file)}
                  ></Button>
                </Col>
              </Row>
            </Card>
          ))
        : null
    }

    return (
      <React.Fragment>
        {informfix ? (
          <>
            {showProjectDetail()}
            <Steps current={this.state.currentStep}>
              {steps.map((item) => (
                <Step key={item.title} title={item.title} />
              ))}
            </Steps>
          </>
        ) : null}
        {!loading ? (
          <React.Fragment>
            <div
              className="steps-content"
              // style={{
              //   height: 400,
              //   overflowX: 'scroll',
              // }}
            >
              {steps[currentStep].content}
            </div>
            <div className="steps-action" align="right">
              {currentStep > 0 && (
                <Button
                  type="dashed"
                  style={{ margin: '0 8px' }}
                  onClick={() => this.prev()}
                  icon={<ArrowLeftOutlined />}
                >
                  ก่อนหน้า
                </Button>
              )}
              {currentStep < steps.length - 1 && (
                <Button
                  type="dashed"
                  onClick={() => this.next()}
                  icon={<ArrowRightOutlined />}
                >
                  ถัดไป
                </Button>
              )}

              {currentStep === steps.length - 1 && (
                <Button
                  type="danger"
                  onClick={() => this.props.hideModal()}
                  icon={<CloseOutlined />}
                >
                  ปิดหน้าต่าง
                </Button>
              )}
            </div>
          </React.Fragment>
        ) : (
          <LoadingOutlined size="larg" style={{ textAlign: 'center' }} />
        )}
      </React.Fragment>
    )
  }
}

export default InformEdit
